export const LOCALE_COOKIE_KEY = 'NEXT_LOCALE';
